module.exports = __webpack_public_path__ + "img/xefe-trans.de5f2002.png";